import { apiFetch } from "./client";

export interface Company {
  id: string;
  name: string;
  slug?: string;
  issuePrefix: string;
  status: string;
  tier: string;
  description: string | null;
  budgetMonthlyCents: number | null;
  spentMonthlyCents: number | null;
  brandColor: string | null;
  logoUrl: string | null;
  onboardingComplete: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCompanyInput {
  name: string;
  slug?: string;
  description?: string;
  tier?: string;
  issuePrefix?: string;
  brandColor?: string;
  logoUrl?: string | null;
}

export const companiesApi = {
  list: () => apiFetch<Company[]>("/companies"),
  get: (id: string) => apiFetch<Company>(`/companies/${id}`),
  create: (data: CreateCompanyInput) =>
    apiFetch<Company>("/companies", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (id: string, data: Partial<CreateCompanyInput>) =>
    apiFetch<Company>(`/companies/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),
  delete: (id: string, confirmText: string) =>
    apiFetch<{
      deleted: boolean;
      company: { id: string; name: string };
      agentsRemoved: number;
      azureResourceGroupsDeleting: string[];
      message: string;
    }>(`/companies/${id}`, {
      method: "DELETE",
      body: JSON.stringify({ confirmText }),
    }),
  removalInventory: (id: string) =>
    apiFetch<{
      company: Company;
      agents: number;
      agentNames: string[];
      azureDeployments: number;
      azureResourceGroups: string[];
      tenantApps: number;
      appServicePlans: number;
      networks: number;
    }>(`/companies/${id}/removal-inventory`),
  provisionAzure: (id: string, region?: string) =>
    apiFetch<{ status: string; network?: unknown; message?: string; error?: string }>(
      `/companies/${id}/provision-azure`,
      {
        method: "POST",
        body: JSON.stringify(region ? { region } : {}),
      },
    ),
};
